import { render, staticRenderFns } from "./GerbangTolUpload.vue?vue&type=template&id=9c67d526&scoped=true"
import script from "./GerbangTolUpload.vue?vue&type=script&lang=js"
export * from "./GerbangTolUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c67d526",
  null
  
)

export default component.exports